/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import Dialog from '@material-ui/core/Dialog';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { connect } from 'react-redux';
import { addAttribute } from '../../../../Actions/Form';
import FinancialOverview from './FinancialOverview';

const Financial = (props) => {
    const saveEwill = (data) => {
        let input = {};
        Object.keys(data).map((item) => {
            input[item] = {
                value: data[item],
            };
        });
        let json = {
          url: input.ID.value ? `important/${input.ID.value}` : 'important',
            method: input.ID.value ? 'PUT' : 'POST',
            system: {
                id: input.ID.value,
            },
            general: {
                name: input.name ? input.name.value : '',
                importantType: 'financial',
                contactID: input.contactID ? input.contactID.value + ';' : '',
            },
            meta: {
                additionalInfo: input.remark ? input.remark.value : '',
                tags: 'tag1;tag2',
            },
            financial: {
                financialType: input.financialType ? input.financialType.value : '',
                paymentPeriod: 'week',
                paymentAmount: input.paymentAmount ? input.paymentAmount.value : '',
                nameInvestment: input.nameInvestment.value,
                accountNumber: input.accountNumber ? input.accountNumber.value : '',
            },
        };
        props.handleRequest('update', json);
        setaddNew(false);
    };

    const [addNew, setaddNew] = React.useState(false);
    const [newRecord, setnewRecord] = React.useState({
        financialType: '',
        paymentPeriod: '',
        nameInvestment: '',
        paymentAmount: '',
        name: '',
        accountNumber: '',
        remark: '',
        contactID: '',
        ID: '',
    });

    React.useEffect(() => {
        if (props.form.accountData && props.form.accountData.importantList) {
            let data = props.form.accountData.importantList.filter((item) => {
                return item.financial;
            });
            let financial = [];
            data.map((item) => {
                financial.push({
                    financialType: item.financial.financialType,
                    paymentPeriod: item.financial.paymentPeriod,
                    nameInvestment: item.financial.nameInvestment,
                    paymentAmount: item.financial.paymentAmount,
                    name: item.general.name,
                    accountNumber: item.financial.accountNumber,
                    contactID: item.general.contactID?.replaceAll(";", ""),
                    remark: item.meta.additionalInfo,
                    ID: item.system.id,
                });
            });
            financial.sort(function (x, y) {
                let a = x.financialType,
                    b = y.financialType;
                return a == b ? 0 : a > b ? 1 : -1;
            });
            setpersonalData(financial);
        } else {
            setpersonalData([]);
        }
    }, [props.form.accountData && props.form.accountData.importantList]);

    const changeHandler = (event, personal) => {
        let data = personalData;

        let newData = newRecord;
        newData[event.target.name] = event.target.value;
        setnewRecord(newData);
        setpersonalData(JSON.parse(JSON.stringify(data)));
    };
    const [personalData, setpersonalData] = React.useState([]);
    const hideEdit = () => {
        setaddNew(false);
    };
    const showAddFinance = (finance) => {
        setaddNew(true);
        if (finance) {
            let newData = {};
            Object.keys(finance).map((item) => {
                newData[item] = finance[item];
            });
            setnewRecord(newData);
            props.addAttribute({
                name: 'selectedFinance',
                value: finance,
            });
        } else {
            setnewRecord({
                financialType: 'alimentation',
                paymentPeriod: '',
                paymentAmount: '',
                name: '',
                accountNumber: '',
                remark: '',
                contactID: '',
                nameInvestment: '',
                ID: '',
            });
            props.addAttribute({
                name: 'selectedFinance',
                value: {},
            });
        }
    };
    return (
      <React.Fragment key={props.key}>
            {addNew === true && (
                <Dialog
                    open={addNew}
                    fullScreen={props.fullScreen}
                    disableEscapeKeyDown={true}
                    onClose={hideEdit}
                    aria-labelledby='responsive-dialog-title'
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                        }}
                    >
                        <div
                            className='mm-form-container'
                        >
                            <div className='mm-login-container' style={{ boxShadow: 'none' }}>
                                <div className='mm-login-header'>
                                    {props.form.selectedFinance && props.form.selectedFinance.ID
                                        ? props.form.language.FINANCIAL_EDIT
                                        : props.form.language.FINANCIAL_ADD}
                                </div>

                                <div>
                                    <div className='login-field-label login-field-label-height'>
                                        {props.form.language.INVESTMENT_LABEL}
                                    </div>
                                    <div className='login-field-input'>
                                        <select
                                            className='mm-field-input '
                                            autoComplete="off"
                                            name={'financialType'}
                                            value={newRecord.financialType}
                                            onChange={(event) => changeHandler(event, newRecord)}
                                        >
                                            <option value=''>
                                                {props.form.language.SELECT_OPTION}
                                            </option>
                                            <option value='alimentation'>
                                                {props.form.language.ALIMONY_LABEL}
                                            </option>
                                            <option value='bankAccount'>
                                                {props.form.language.BANKING_LABEL}
                                            </option>
                                            <option value='invest'>
                                                {props.form.language.INVESTMENT_LABEL}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                {newRecord.financialType === 'alimentation' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {props.form.language.CONTACT_PERSON_TITLE}
                                        </div>
                                        <div className='login-field-input'>
                                            <select
                                                className='mm-field-input '
                                                autoComplete="off"
                                                name={'contactID'}
                                                value={newRecord.contactID}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            >
                                                <option value=''>
                                                    {props.form.language.SELECT_OPTION}
                                                </option>
                                                {props.contactList?.map(
                                                        (contact) => {
                                                            if (contact) {
                                                                return (
                                                                    <option
                                                                        value={contact.system.id}
                                                                    >
                                                                        {contact.privateData
                                                                            .firstName +
                                                                            ' ' +
                                                                            contact.privateData
                                                                                .lastName}
                                                                    </option>
                                                                );
                                                            }
                                                        }
                                                    )}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                {newRecord.financialType === 'alimentation' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {props.form.language.AMOUNT_PER_MONTH}
                                        </div>
                                        <div className='login-field-input'>
                                            <input
                                                type='text'
                                                autoComplete="off"
                                                placeholder={props.form.language.AMOUNT_PER_MONTH}
                                                name='paymentAmount'
                                                value={newRecord.paymentAmount}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}

                                {newRecord.financialType === 'invest' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {props.form.language.INVESTMENT_DESC}
                                        </div>
                                        <div className='login-field-input'>
                                            <input
                                                type='text'
                                                autoComplete="off"
                                                placeholder={props.form.language.INVESTMENT_DESC}
                                                name='nameInvestment'
                                                value={newRecord.nameInvestment}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {newRecord.financialType === 'invest' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {newRecord.financialType === 'invest' ? props.form.language.INVESTMENT_INFO :  props.form.language.DESCRIPTION_LABEL}
                                        </div>
                                        <div className='login-field-input'>
                                            <textarea
                                                style={{ height: 'auto' }}
                                                rows='4'
                                                autoComplete="off"
                                                type='text'
                                                placeholder={newRecord.financialType === 'invest' ? props.form.language.INVESTMENT_INFO :  props.form.language.DESCRIPTION_LABEL}
                                                name='remark'
                                                value={newRecord.remark}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {newRecord.financialType !== '' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {props.form.language.BANK_NAME}
                                        </div>
                                        <div className='login-field-input'>
                                            <input
                                                type='text'
                                                autoComplete="off"
                                                placeholder={props.form.language.BANK_NAME}
                                                name='name'
                                                value={newRecord.name}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {newRecord.financialType !== '' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {props.form.language.ACCOUNT_NUMBER}
                                        </div>
                                        <div className='login-field-input'>
                                            <input
                                                type='text'
                                                autoComplete="off"
                                                placeholder={props.form.language.ACCOUNT_NUMBER}
                                                name='accountNumber'
                                                value={newRecord.accountNumber}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {newRecord.financialType === 'bankAccount' && (
                                    <div>
                                        <div className='login-field-label login-field-label-height'>
                                            {newRecord.financialType === 'invest' ? props.form.language.INVESTMENT_INFO :  props.form.language.DESCRIPTION_LABEL}
                                        </div>
                                        <div className='login-field-input'>
                                            <textarea
                                                style={{ height: 'auto' }}
                                                rows='4'
                                                autoComplete="off"
                                                type='text'
                                                placeholder={newRecord.financialType === 'invest' ? props.form.language.INVESTMENT_INFO :  props.form.language.DESCRIPTION_LABEL}
                                                name='remark'
                                                value={newRecord.remark}
                                                onChange={(event) =>
                                                    changeHandler(event, newRecord)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                <div
                                    className='mm-input-submit'
                                    style={{
                                        display: 'flex',
                                        marginBottom: '15px',
                                        justifyContent: 'center',
                                    }}
                                >
                                    
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            width: '150px',
                                            marginTop: '24px',
                                            marginRight: '20px',
                                        }}
                                        className='primary-button-blue'
                                        onClick={() => {
                                            saveEwill(newRecord);
                                            hideEdit();
                                        }}
                                    >
                                        {props.form.language.SAVE}
                                    </button>
                                    <button
                                        style={{
                                            textAlign: 'center',
                                            marginTop: '24px',
                                            
                                        }}
                                        className='secondary-button'
                                        onClick={hideEdit}
                                    >
                                        {props.form.language.CANCEL}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            )}
            {personalData &&
                personalData.length > 0 &&
                personalData.map((data) => {
                    return (
                        <FinancialOverview
                        key={`finance${data.ID}`}
                            data={data}
                            showAddFinance={() => showAddFinance(data)}
                            handleRequest={(type, data) => props.handleRequest(type, data)}
                            contactList={props.contactList}
                        />
                    );
                })}
            <span
                id={props.type}
                onClick={(event) => {
                    showAddFinance();
                }}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '8px',
                }}
            >
                <span className=''>
                    <span className='ewill-secondary-alert-sm'>
                        <AddIcon />
                    </span>
                </span>
                <span className='momentio-text-normal' style={{ marginLeft: '15px' }}>
                    {props.form.language.FINANCIAL_ADD_SINGLE}
                </span>
            </span>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return { ...state };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addAttribute: (payload) => dispatch(addAttribute(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Financial);
